// import Login from "@/components/Login";
// import Register from "@/components/Register";
// import ResetPassword from "@/components/ResetPassword";
import AppHome from "@/components/AppHome";
import Home from "@/components/Home";
import Space from "@/components/Space";
import Mine from "@/components/Mine";
import History from "@/components/History";
import Favorite from "@/components/Favorite";
import Setting from "@/components/Setting";
import Search from "@/components/Search";
import Notice from "@/components/Notice"; //通知公告
import About from "@/components/About"; //关于我们
import Contact from "@/components/Contact"; //联系我们
import Opinion from "@/components/Opinion"; //意见反馈
import Download from "@/components/Download"; //下载页

const routes = [
  {
    path: "/",
    name: "AppHome",
    component: AppHome,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "首页",
        component: Home
      },
      {
        path: "/space",
        name: "模块导航",
        component: Space
      },
      {
        path: "/notice",
        name: "通知",
        component: Notice
      },
      {
        path: "/about",
        name: "关于",
        component: About
      },
      {
        path: "/contact",
        name: "联系我们",
        component: Contact
      },
      {
        path: "/opinion",
        name: "Opinion",
        component: Opinion
      },
      {
        path: "/download",
        name: "Download",
        component: Download
      },
      {
        path: "/mine",
        name: "Mine",
        component: Mine,
        children: [
          {
            path: "/mine/history",
            name: "History",
            component: History
          },
          {
            path: "/mine/favorite",
            name: "Favorite",
            component: Favorite
          },
          {
            path: "/mine/setting",
            name: "Setting",
            component: Setting
          }
        ]
      },
      {
        path: "/search",
        name: "Search",
        component: Search
      }
    ]
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: Login
  // },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: Register
  // },
  // {
  //   path: "/resetpassword",
  //   name: "ResetPassword",
  //   component: ResetPassword
  // },
  {
    path: "*",
    component: AppHome
  }
];

export default routes;
